<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      :right="main.rtl"
      dense
      class="d-print-none"
    >
      <v-list dense>
        <v-list-item v-if="!!user" class="mb-2">
          <v-list-item-avatar>
            <v-img
              :src="'/storage/' + user.avatar"
              lazy-src="/storage/default_img/no_image.png"
              aspect-ratio="1"
              max-width="50"
              max-height="50"
            />
          </v-list-item-avatar>
          <v-list-item-title>
            <v-badge :content="user.roleName" color="info" inline>
              {{ user.name }}
            </v-badge>
          </v-list-item-title>
        </v-list-item>
        <v-divider />

        <v-list-item link :to="{ name: 'Dashboard' }">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'Products' }">
          <v-list-item-action>
            <v-icon>mdi-sitemap</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Products</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'PosSale' }">
          <v-list-item-action>
            <v-icon>mdi-cart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Sale</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Buy' }">
          <v-list-item-action>
            <v-icon>mdi-cart-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Buy</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'CustomProductList' }">
          <v-list-item-action>
            <v-icon>mdi-animation</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Buy From Customer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'RepiarList' }">
          <v-list-item-action>
            <v-icon>mdi-shape-square-plus</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Repair</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'GalleryList' }">
          <v-list-item-action>
            <v-icon>mdi-image-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Repair Gallery</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'ShopList' }">
          <v-list-item-action>
            <v-icon>mdi-pentagon</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Shop Listing</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'BillList' }">
          <v-list-item-action>
            <v-icon>mdi-locker-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Bills</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'Contacts' }">
          <v-list-item-action>
            <v-icon>mdi-account-multiple-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contacts</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Stocks' }">
          <v-list-item-action>
            <v-icon>mdi-store</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Stocks</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Inventory' }">
          <v-list-item-action>
            <v-icon>mdi-alert-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Inventory</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'TransactionMain' }">
          <v-list-item-action>
            <v-icon>mdi-chart-bar-stacked</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Transactions</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Payments' }">
          <v-list-item-action>
            <v-icon>mdi-cash-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Payments</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Reports' }">
          <v-list-item-action>
            <v-icon>mdi-note-multiple-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Reports</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Backup' }">
          <v-list-item-action>
            <v-icon>mdi-database-lock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Backups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Users' }">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{ name: 'Settings' }">
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click.prevent="logout">
          <v-list-item-action>
            <v-icon>mdi-power</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark dense class="d-print-none">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        {{ main.site_name }}
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon href="/welcome">
        <v-icon>mdi-home-outline</v-icon>
      </v-btn>
      <v-btn icon :to="{ name: 'PosSale' }">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
      <v-btn icon class="mr-3" @click="logout">
        <v-icon>mdi-power</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid class="px-0">
        <div>
          <router-view />
        </div>
      </v-container>
    </v-main>
    <v-footer color="indigo" app dense class="d-print-none">
      <span class="white--text"
        >&copy; {{ new Date().getFullYear() }} {{ main.site_name }}. All rights
        reserved
      </span>

      <v-spacer />
      <span class="white--text">By : Rose-Finch - {{ main.version }} v</span>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    drawer: null,
  }),
  computed: {
    ...mapGetters({
      main: "configs/overall",
      user: "auth/user",
    }),
  },
  created() {
    Event.$on("hideDrawer", () => {
      this.$data.drawer = false;
    });
    Event.$on("showDrawer", () => {
      this.$data.drawer = true;
    });
  },
  methods: {
    logout() {
      Event.$emit("logout");
    },
  },
};
</script>
